function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
requireAll( require.context( './gif/', true, /\.gif$/) );
requireAll( require.context( './fonts/', true ) );

import $ from 'jquery';

window.jQuery = $;
window.$ = $;

$(function () {


	var stickyBar = document.getElementById( 'header' );
	var startBarHeight = stickyBar.offsetHeight;
	var endBarHeight = startBarHeight - 32;


	var stickyLogo = document.getElementById( 'logo' );
	var startHeightLogo = stickyLogo.offsetHeight;

	var stickyLogoLink = document.getElementById( 'logolink' );
	var startTopLogo = stickyLogoLink.offsetTop;
	
	var lastScrollOffset = window.pageYOffset;

	var navOpen = false;

	stickyLogo.style.height = startHeightLogo + 'px';
	//stickyLogo.style.width = 'auto';

	var PROJECT = {

		common: {

			init: function() {

				$( document ).on( 'click', '[data-lightbox]', PROJECT.lightbox.open );
				$( document ).on( 'mouseup touchend keyup', PROJECT.lightbox.close );
				

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );
				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );

				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );


				$( document ).on( 'click', '.backToTop', PROJECT.nav.backtotop );
				$( document ).on( 'click', '.toggleNav', PROJECT.nav.toggle );

				$( window ).on( 'scroll', PROJECT.scroll.init );

	
			}

		},

		nav : {	

			backtotop: function(e) {

				e.preventDefault();

				$( 'html,body' ).animate({

					scrollTop: (0)

				}, 1000);
			},
			
			toggle: function(e) {

				e.preventDefault();

				if ( !navOpen ) {

					$('html').addClass( 'nav-open' );

					navOpen = true;

				} else if ( navOpen ) {

					$('html').removeClass( 'nav-open' );

					navOpen = false;

				}

			}

		},

		lightbox: {

			open: function( e ) {

				e.preventDefault();

				var newSrc = $( this ).data( 'lightbox' );

				var link = $( this ).data( 'link' );

				var client = $( this ).data( 'client' );

				var type = $( this ).data( 'type' );

				var $parent = $( this ).closest( '.sectionLightbox' );

				if ( type == 'video' ) {

					$parent.find( '.videoSrc' ).attr( 'src', newSrc + '&autoplay=1');

					$parent.addClass( 'section-portfolio--show-lightbox-video' );

				}

				if ( type == 'image' ) {

					$parent.find( '.imageSrc' ).attr( 'src', newSrc);

					$parent.addClass( 'section-portfolio--show-lightbox-image' );

				} 

				if ( link.url && link.label ) {

					$parent.find( '.linkUrl' ).attr( 'href', link.url ).text( link.label );

				}

				if ( client.url && client.name ) {

					$parent.find( '.clientUrl' ).attr( 'href', client.url ).text( client.name );

				}

			},

			close: function ( e ) {

				var lightbox = $( '.lightboxClose' );

				var $parent = $( '.lightbox' ).closest( '.sectionLightbox' );

				console.log( e );
			
				if ( lightbox.is(e.target) || e.keyCode == 27 ) {

					$parent.removeClass( 'section-portfolio--show-lightbox-video' );

					$parent.removeClass( 'section-portfolio--show-lightbox-image' );

					$parent.find( '.videoSrc' ).attr( 'src', '' );

					$parent.find( '.imageSrc' ).attr( 'src', '' );
					
					$parent.find( '.clientUrl' ).attr( 'href', '#' ).text( '' );

					$parent.find( '.linkUrl' ).attr( 'href', '#' ).text( '' );

				}
			}
		},

		gform: {

			showLoader: function() {

				$( '.gformLoader' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideLoader: function() {

				$( '.gformLoader' ).fadeOut( 300 );

			},

			showConfirmation: function() {

				$( '.gformConfirmation' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideConfirmation: function() {

				$( '.gformConfirmation' ).fadeOut( 300 );

			}

		}, 

		scroll: {

			init: function() {

				var currentScrollOffset = window.pageYOffset || document.documentElement.scrollTop; 

				if ( $(window).width() > 768 ) {
				
					
					var duration = 400;
					var start = 0;
					var end = start + duration;				
					var amount = startBarHeight - endBarHeight;				
					

					
					var scrollDirection =  currentScrollOffset > lastScrollOffset ? 1 : 0; // 1 == down
				
					lastScrollOffset = currentScrollOffset <= 0 ? 0 : currentScrollOffset;
					
					if ( currentScrollOffset > start && currentScrollOffset <= end ) {

						if ( scrollDirection == 1 ) {

							var newBarHeight = startBarHeight - ( amount / duration ) * ( lastScrollOffset - start );

						} else {

							var newBarHeight = startBarHeight - ( amount / duration ) * ( lastScrollOffset + start );
						}

						stickyBar.style.height = newBarHeight + 'px';

					} else if ( currentScrollOffset <= start ) {

						stickyBar.style.height = startBarHeight + 'px';

					} else {

						stickyBar.style.height = endBarHeight + 'px';
					}

				} else {

					if ( currentScrollOffset > $(window).height() ) {

						$( '.backToTop' ).addClass( 'is-visible' );

					} else {

						$( '.backToTop' ).removeClass( 'is-visible' );

					}

				}
			}
		}

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);


});
